import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";
import styled from "styled-components";

export const SeasonCampaignWrapper = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(90deg, #435993 0%, #16275D 45%);
    padding: 9px 24px;
`;

export const Percentage = styled.span`
    color: ${colorsPalettes.orange[300]};
    font-size: 22px;
    font-weight: 700;
`;

export const Off = styled.span`
    font-size: 16px;
`;

export const CloseIconButton = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 0;
    width: 37px !important;
    height: 37px;
    padding: 0;
    margin: 0;
`;
